import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import renukadoc from './../../../../assets/images/Doctorsimages/dr.renuka_new.png'
import favicon from "./../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'

const RenukaDoc = () => {
  const navigate = useNavigate();
   useEffect(() => {
       document.title = "Best Homeopathy Doctor in Jayanagar, Bangalore | Dr. Renuka – H-Cura";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Renuka E, Senior Consultant at H-Cura Homeopathy, Jayanagar. Trusted homeopathy doctor in JP Nagar, Banashankari, BTM Layout & nearby areas."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "Homeopathy doctor in Jayanagar, Best homeopathy doctor in JP Nagar, Homeopathy specialist in Banashankari, Homeopathy consultant in BTM Layout, Best homeopathy clinic in Jayanagar, Homeopathy doctor near Basavanagudi, Homeopathy treatment near Wilson Garden, Top homeopathy doctor near Bannerghatta Road"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://h-cura.com/doctors/dr-renuka-e-best-homeopathy-doctor-jayanagar-bangalore");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://h-cura.com/doctors/dr-renuka-e-best-homeopathy-doctor-jayanagar-bangalore");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);


     const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');

  // Add PDF-specific class to container
  container.classList.add('veenadoc-pdf-mode');

  // Store original styles
  const originalStyles = new Map();

  // Temporarily modify styles for PDF capture
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  // Fix hero section height for PDF
  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  // Ensure images are fully loaded and visible
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  // Wait a moment for styles to apply
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      // Remove PDF-specific class
      container.classList.remove('veenadoc-pdf-mode');

      // Restore original styles
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      // Restore hero section
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Define margins for the PDF
      const marginLeft = 10; // 10mm gap on the left
      const marginRight = 10; // 10mm gap on the right to maintain symmetry and prevent cutting
      const availableWidth = pdfWidth - marginLeft - marginRight;

      // Calculate scaling factor to fit the canvas content within the available width
      const scaleFactor = availableWidth / canvasWidth;

      // Apply the scale factor to both width and height to maintain aspect ratio
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;

      // Calculate the number of pages needed for vertical content overflow
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        // Add image to PDF, using marginLeft for the x coordinate
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Renuka_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');

      // Remove PDF-specific class
      container.classList.remove('veenadoc-pdf-mode');

      // Restore hero section
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Renuka E</span>
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                  <span className="veenadoc-title-location">Jayanagar, Bangalore</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    One of the most experienced and trusted homeopathy doctors in Jayanagar, Bangalore, currently practicing as a Senior Consultant at H-Cura Multispeciality Homeopathy Clinic. With over <strong>15</strong>  years of professional experience, she has helped thousands of patients achieve long-term relief from chronic and acute health conditions.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')}
            >
              <span className="veenadoc-btn-icon">📞</span>
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div>
            </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={renukadoc} alt="Dr. Renuka E – Best Homeopathy Doctor in Jayanagar, Bangalore" className="veenadoc-doctor-image" title='Dr. Renuka E – Best Homeopathy Doctor in Jayanagar, Bangalore' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Renuka E</h2>
                  <p>
                    Dr. Renuka E is one of the most experienced and trusted homeopathy doctors in Jayanagar, Bangalore, currently practicing as a Senior Consultant at H-Cura Multispeciality Homeopathy Clinic. With over 15 years of professional experience, she has helped thousands of patients achieve long-term relief from chronic and acute health conditions. Known for her patient-centered approach and holistic treatments, she is widely regarded as the best homeopathy doctor in Jayanagar and is also highly sought after by patients living in nearby localities such as JP Nagar, Banashankari, BTM Layout, Basavanagudi, Wilson Garden, and Bannerghatta Road.
                  </p>
                  <p>
                    Patients looking for homeopathy clinics near Jayanagar often choose H-Cura because of its reputation, and many of them prefer to consult specifically with Dr. Renuka due to her track record of successful outcomes. Whether it is for skin diseases, respiratory problems, hormonal disorders, or lifestyle-related illnesses, she provides personalized treatment plans that focus on the root cause rather than temporary relief.
                  </p>
                </div>

                {/* Education & Training */}
                <div className="veenadoc-article-block">
                  <h2>Education & Professional Training</h2>
                  <p>
                    Dr. Renuka completed her BHMS from HKE Society Homeopathy Medical College and further enhanced her skills through advanced clinical research training under Dr. M.S. Patil. Her education and training have given her a strong foundation in both classical homeopathy and evidence-based clinical practice, enabling her to combine traditional methods with modern understanding.
                  </p>
                </div>

               
                     <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">15+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Jayanagar, Bangalore</span>
                    </div>
                  </div>
                </div>

                {/* Professional Experience */}
                <div className="veenadoc-article-block">
                  <h2>Professional Experience & Career Journey</h2>
                  <p>
                    Her career spans more than 15 years across several reputed hospitals, clinics, and medical institutions. She has served as Duty Medical Officer at Vijaya Health Care, Basanth Sahani Multispeciality Hospital, and Dr. M.S. Patil Multispeciality Hospital, worked as a physician assistant at CARE Hospitals, served as Resident Medical Officer at Devas Homeopathy Medical College, and gained valuable experience at Healthy Homeopathy Clinic and Getha Nursing Home.
                  </p>
                  <p>
                    For the last two years, she has been serving patients at H-Cura Multispeciality Homeopathy Clinic, Jayanagar, where she is recognized as a leading homeopathy specialist near JP Nagar and Banashankari.
                  </p>
                </div>

                {/* Areas of Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Areas of Expertise</h2>
                  <p>
                    Her areas of expertise are broad, covering both acute and chronic conditions. She specializes in skin problems such as acne, psoriasis, dermatitis, pigmentation, and vitiligo; respiratory diseases like asthma, bronchitis, and pulmonary fibrosis; women's health issues such as PCOS, thyroid disorders, and menstrual irregularities; and lifestyle-related conditions including anxiety, sleep disorders, diabetes-related kidney problems, piles, fatty liver, and varicose veins.
                  </p>
                  <p>
                    Many patients searching for a homeopathy doctor near BTM Layout or Basavanagudi consult her because of her reputation for natural and safe treatments.
                  </p>
                </div>

                {/* Treatment Approach */}
                <div className="veenadoc-article-block">
                  <h2>Holistic Treatment Approach</h2>
                  <p>
                    At H-Cura Homeopathy Clinic in Jayanagar, Dr. Renuka follows a holistic treatment approach. She carefully studies each patient's complete medical history, emotional state, lifestyle, and genetic background before prescribing remedies. This individualized approach ensures that patients receive treatment plans that are safe, natural, and highly effective.
                  </p>
                  <p>
                    Many patients from JP Nagar 2nd Phase, Banashankari 2nd Stage, BTM Layout 1st Stage, Wilson Garden, and Bannerghatta Road visit her clinic for homeopathy consultations because of her commitment to long-term health improvement.
                  </p>
                </div>

                {/* Patient Success */}
                <div className="veenadoc-article-block">
                  <h2>Patient Success & Recognition</h2>
                  <p>
                    Patients often recommend Dr. Renuka as the best homeopathy doctor near JP Nagar and a highly trusted homeopathy consultant in Banashankari and BTM Layout, thanks to her dedication and results. She has successfully treated numerous cases where patients had been suffering from chronic illnesses for years without relief from conventional medicine.
                  </p>
                  <p>
                    Her ability to provide natural and side-effect-free solutions makes her a preferred choice among families across South Bangalore.
                  </p>
                </div>

                {/* H-Cura Clinic */}
                <div className="veenadoc-article-block">
                  <h2>H-Cura Multispeciality Homeopathy Clinic</h2>
                  <p>
                    The H-Cura Multispeciality Homeopathy Clinic in Jayanagar is considered one of the best homeopathy clinics in Bangalore. Patients from surrounding areas such as JP Nagar, Banashankari, Basavanagudi, Wilson Garden, BTM Layout, and Bannerghatta Road regularly consult here for homeopathy treatments.
                  </p>
                  <p>
                    With both offline consultations at the Jayanagar clinic and online consultations across India and abroad, Dr. Renuka ensures accessibility and continuity of care for all her patients.
                  </p>
                </div>

                {/* Philosophy */}
                <div className="veenadoc-article-block">
                  <h2>Patient-First Philosophy</h2>
                  <p>
                    What sets Dr. Renuka apart is her patient-first philosophy. She not only prescribes homeopathy medicines but also guides her patients with lifestyle management, preventive care, and emotional well-being. For her, healing is not just about treating diseases but about helping patients live healthier and more fulfilling lives.
                  </p>
                  <p>
                    This is why she is consistently ranked among the top homeopathy doctors in Jayanagar and nearby areas.
                  </p>
                </div>

                {/* Patient Reviews */}
                <div className="veenadoc-article-block">
                  <h2>Patient Reviews & Recommendations</h2>
                  <p>
                    Many patients searching for a homeopathy clinic near JP Nagar 6th Phase, a homeopathy doctor in Banashankari 3rd Stage, or the best homeopathy consultant near BTM Layout 2nd Stage end up visiting her at H-Cura Jayanagar after reading positive reviews and recommendations.
                  </p>
                  <p>
                    Her empathetic consultation style, deep medical knowledge, and focus on holistic healing make her a trusted doctor not just in Jayanagar but also in Basavanagudi, Wilson Garden, Lalbagh Road, and Bannerghatta Road.
                  </p>
                </div>

                {/* When to Consult */}
                <div className="veenadoc-article-block">
                  <h2>When to Consult Dr. Renuka</h2>
                  <p>
                    If you are suffering from chronic conditions like thyroid disorders, PCOS, arthritis, psoriasis, kidney problems, or respiratory diseases and are searching for a homeopathy doctor near Jayanagar, JP Nagar, Banashankari, BTM Layout, or Basavanagudi, then Dr. Renuka E is the right choice for you.
                  </p>
                  <p>
                    She is also highly recommended for those living near Wilson Garden and Bannerghatta Road who want natural treatments without side effects.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Renuka E for Natural Healing</h2>
                  <p>
                    Booking an appointment with Dr. Renuka is simple. Patients can walk into H-Cura Multispeciality Homeopathy Clinic in Jayanagar or book an online consultation from anywhere in Bangalore or across the globe. With personalized care, natural medicines, and continuous follow-up, she ensures patients recover fully and maintain their health in the long run.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Choose safe, natural, and effective healing</strong> with Dr. Renuka E, the best homeopathy doctor in Jayanagar, Bangalore, and surrounding areas like JP Nagar, Banashankari, BTM Layout, Basavanagudi, Wilson Garden, and Bannerghatta Road.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Healing is not just about treating diseases but about helping patients live healthier and more fulfilling lives"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Renuka E's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes that true healing goes beyond temporary relief of symptoms and requires addressing the root cause of illness. This patient-centric approach has positioned her among the best holistic homeopathy doctors in Jayanagar and surrounding areas.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Multispeciality Homeopathy Clinic</h4>
                      <p>Jayanagar, Bangalore</p>
                    </div>
                  </div>
                </div>

                {/* Service Areas */}
                <div className="veenadoc-sidebar-card">
                  <h3>Service Areas</h3>
                  <ul className="veenadoc-services-list">
                    <li>🏥 Jayanagar</li>
                    <li>🏥 JP Nagar</li>
                    <li>🏥 Banashankari</li>
                    <li>🏥 BTM Layout</li>
                    <li>🏥 Basavanagudi</li>
                    <li>🏥 Wilson Garden</li>
                    <li>🏥 Bannerghatta Road</li>
                  </ul>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience holistic healthcare with Dr. Renuka's personalized approach.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default RenukaDoc
